/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListPaymentLinksGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ListPaymentLinksRequest = {
  skip?: number | undefined;
  count?: number | undefined;
  type?: components.PaymentLinkType | undefined;
  status?: components.PaymentLinkStatus | undefined;
  /**
   * The merchant account ID.
   */
  accountID: string;
};

export type ListPaymentLinksResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.PaymentLink>;
};

/** @internal */
export const ListPaymentLinksGlobals$inboundSchema: z.ZodType<
  ListPaymentLinksGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListPaymentLinksGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListPaymentLinksGlobals$outboundSchema: z.ZodType<
  ListPaymentLinksGlobals$Outbound,
  z.ZodTypeDef,
  ListPaymentLinksGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listPaymentLinksGlobalsToJSON(
  listPaymentLinksGlobals: ListPaymentLinksGlobals,
): string {
  return JSON.stringify(
    ListPaymentLinksGlobals$outboundSchema.parse(listPaymentLinksGlobals),
  );
}
export function listPaymentLinksGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListPaymentLinksGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPaymentLinksGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPaymentLinksGlobals' from JSON`,
  );
}

/** @internal */
export const ListPaymentLinksRequest$inboundSchema: z.ZodType<
  ListPaymentLinksRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  type: components.PaymentLinkType$inboundSchema.optional(),
  status: components.PaymentLinkStatus$inboundSchema.optional(),
  accountID: z.string(),
});
/** @internal */
export type ListPaymentLinksRequest$Outbound = {
  skip?: number | undefined;
  count?: number | undefined;
  type?: string | undefined;
  status?: string | undefined;
  accountID: string;
};

/** @internal */
export const ListPaymentLinksRequest$outboundSchema: z.ZodType<
  ListPaymentLinksRequest$Outbound,
  z.ZodTypeDef,
  ListPaymentLinksRequest
> = z.object({
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  type: components.PaymentLinkType$outboundSchema.optional(),
  status: components.PaymentLinkStatus$outboundSchema.optional(),
  accountID: z.string(),
});

export function listPaymentLinksRequestToJSON(
  listPaymentLinksRequest: ListPaymentLinksRequest,
): string {
  return JSON.stringify(
    ListPaymentLinksRequest$outboundSchema.parse(listPaymentLinksRequest),
  );
}
export function listPaymentLinksRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListPaymentLinksRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPaymentLinksRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPaymentLinksRequest' from JSON`,
  );
}

/** @internal */
export const ListPaymentLinksResponse$inboundSchema: z.ZodType<
  ListPaymentLinksResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.PaymentLink$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListPaymentLinksResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.PaymentLink$Outbound>;
};

/** @internal */
export const ListPaymentLinksResponse$outboundSchema: z.ZodType<
  ListPaymentLinksResponse$Outbound,
  z.ZodTypeDef,
  ListPaymentLinksResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.PaymentLink$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listPaymentLinksResponseToJSON(
  listPaymentLinksResponse: ListPaymentLinksResponse,
): string {
  return JSON.stringify(
    ListPaymentLinksResponse$outboundSchema.parse(listPaymentLinksResponse),
  );
}
export function listPaymentLinksResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListPaymentLinksResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPaymentLinksResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPaymentLinksResponse' from JSON`,
  );
}
